module.exports = __webpack_public_path__ + "img/placeholder.b29875f6.png";